(function () {
  const DEFAULT_STEPS = [
    {
      titleKey: 'playerProfile',
      title: 'Player Profile',
      labels: ['side', 'stick height', 'cote', 'hauteur / longueur', 'hauteur', 'longueur']
    },
    {
      titleKey: 'specifications',
      title: 'Specifications',
      labels: ['stick curve', 'stick lie', 'stick flex', 'kick point', 'grip', 'blade finish', 'stick finish', 'courbe', 'flex', 'prise', 'fini de la lame']
    },
    {
      titleKey: 'carbonWeight',
      title: 'Carbon & Weight',
      labels: ['carbon fiber weave', 'weight', 'type de fibre de carbone', 'poids du baton']
    },
    {
      titleKey: 'colorName',
      title: 'Color & Name',
      labels: ['graphics & colors', 'graphics color', 'name to be printed on your stick', 'warranty period', 'graphiques et couleurs', 'couleur des graphiques', 'nom a imprimer sur votre baton', 'periode de garantie']
    }
  ];

  const STEPPER_CONFIGS = [
    {
      name: 'hyperionCustom',
      productIds: ['12307155550526', '12337413914942'],
      pathHandles: ['hyperion-custom-hockey-stick', 'hyperion-hockey-stick'],
      className: 'chs-aco-stepper--hyperion-custom',
      steps: [
        {
          titleKey: 'playerProfile',
          title: 'Player Profile',
          labels: ['side', 'stick height', 'cote', 'hauteur / longueur', 'hauteur', 'longueur']
        },
        {
          titleKey: 'specifications',
          title: 'Specifications',
          labels: ['stick curve', 'stick lie', 'stick flex', 'kick point', 'shaft type', 'grip', 'blade finish', 'stick finish', 'courbe', 'flex', 'profil du manche', 'prise', 'fini de la lame']
        },
        {
          titleKey: 'colorName',
          title: 'Color & Name',
          labels: ['color', 'name to be printed on your stick', 'warranty period', 'couleur', 'nom a imprimer sur votre baton', 'periode de garantie']
        }
      ]
    },
    {
      name: 'edmontonVintage',
      templateClasses: ['template-product-edmonton-vintage'],
      pathHandles: ['custom-edmonton'],
      className: 'chs-aco-stepper--edmonton-vintage',
      steps: [
        {
          titleKey: 'playerProfile',
          title: 'Player Profile',
          labels: ['side', 'stick height', 'cote', 'hauteur / longueur', 'hauteur', 'longueur']
        },
        {
          titleKey: 'specifications',
          title: 'Specifications',
          labels: ['stick curve', 'stick lie', 'stick flex', 'kick point', 'grip', 'blade finish', 'stick finish', 'courbe', 'flex', 'prise', 'fini de la lame']
        },
        {
          titleKey: 'colorName',
          title: 'Color & Name',
          labels: ['carbon color', 'color', 'name to be printed on your stick', 'warranty period', 'couleur du carbone', 'couleur', 'nom a imprimer sur votre baton', 'periode de garantie']
        }
      ]
    }
  ];

  const TRANSLATIONS = {
    en: {
      next: 'Next',
      playerProfile: 'Player Profile',
      specifications: 'Specifications',
      carbonWeight: 'Carbon & Weight',
      colorName: 'Color & Name'
    },
    fr: {
      next: 'Suivant',
      playerProfile: 'Profil du joueur',
      specifications: 'Spécifications',
      carbonWeight: 'Carbone et poids',
      colorName: 'Couleur et nom'
    }
  };

  const READY_CLASS = 'chs-aco-stepper-ready';
  const HEADER_CLASS = 'chs-aco-step-header-row';
  const ACTIONS_CLASS = 'chs-aco-step-actions-row';
  const END_ROW_CLASS = 'chs-aco-step-row--end';
  const MAX_ATTEMPTS = 80;
  let attempts = 0;

  function normalize(value) {
    return (value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\*/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function getLocale() {
    const lang =
      document.documentElement.getAttribute('lang') ||
      document.documentElement.getAttribute('xml:lang') ||
      window.Shopify && window.Shopify.locale ||
      'en';

    return String(lang).toLowerCase().indexOf('fr') === 0 ? 'fr' : 'en';
  }

  function translate(key) {
    const locale = getLocale();
    return (TRANSLATIONS[locale] && TRANSLATIONS[locale][key]) || TRANSLATIONS.en[key] || key;
  }

  function getFieldLabel(row) {
    const label = row.querySelector('.wcpa_field_label');
    return normalize(label ? label.textContent : '');
  }

  function getDefaultConfig() {
    return {
      name: 'default',
      className: '',
      steps: DEFAULT_STEPS
    };
  }

  function getProductId(form) {
    const addonWrapper = form.closest('.aco_addon_wrapper[data-product-id]');
    return addonWrapper ? addonWrapper.getAttribute('data-product-id') : '';
  }

  function getStepperConfig(form) {
    const productId = getProductId(form);
    const path = window.location && window.location.pathname ? window.location.pathname : '';

    return STEPPER_CONFIGS.find((config) => {
      const matchesProduct = config.productIds && config.productIds.indexOf(productId) !== -1;
      const matchesPath = config.pathHandles && config.pathHandles.some((handle) => path.indexOf(`/products/${handle}`) !== -1);
      const matchesTemplate = config.templateClasses && config.templateClasses.some((cls) => document.body.classList.contains(cls));
      return matchesProduct || matchesPath || matchesTemplate;
    }) || getDefaultConfig();
  }

  function findStepIndex(label, fallbackIndex, steps) {
    if (!label) {
      return fallbackIndex;
    }

    const index = steps.findIndex((step) => step.labels.some((stepLabel) => label === stepLabel || label.indexOf(stepLabel) !== -1));
    return index === -1 ? fallbackIndex : index;
  }

  function getDirectRows(sectionBody) {
    return Array.from(sectionBody.children).filter((row) => row.classList.contains('wcpa_row'));
  }

  function getManagedRows(sectionBody) {
    return getDirectRows(sectionBody).filter((row) => !row.classList.contains(HEADER_CLASS) && !row.classList.contains(ACTIONS_CLASS));
  }

  function isVisible(element) {
    if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') {
      return false;
    }

    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') {
      return false;
    }

    return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
  }

  function hydrateSelectedInputs(form) {
    form.querySelectorAll('.wcpa_radio.wcpa_selected, .wcpa_checkbox.wcpa_selected, .wcpa_color_selected').forEach((selectedOption) => {
      const input = selectedOption.querySelector('input[type="radio"], input[type="checkbox"]');

      if (input && !input.checked) {
        input.checked = true;
      }
    });
  }

  function syncSelectionState(form) {
    form.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked').forEach((input) => {
      const selectedOption = input.closest('.wcpa_radio, .wcpa_checkbox');
      const selectedColor = input.closest('.wcpa_color, .wcpa_color_wrap');

      if (selectedOption) {
        selectedOption.classList.add('wcpa_selected');
      }

      if (selectedColor) {
        selectedColor.classList.add('wcpa_color_selected');
      }
    });

    form.querySelectorAll('.wcpa_radio.wcpa_selected, .wcpa_checkbox.wcpa_selected').forEach((selectedOption) => {
      const input = selectedOption.querySelector('input[type="radio"], input[type="checkbox"]');

      if (input && !input.checked) {
        selectedOption.classList.remove('wcpa_selected');
      }
    });
  }

  function isFieldValid(fieldWrap) {
    if (!isVisible(fieldWrap)) {
      return true;
    }

    const label = fieldWrap.querySelector('.wcpa_field_label');
    const isRequired =
      fieldWrap.querySelector('.wcpa_required_ast') ||
      fieldWrap.querySelector('[required]') ||
      (label && label.textContent.indexOf('*') !== -1);

    if (!isRequired) {
      return true;
    }

    if (fieldWrap.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked')) {
      return true;
    }

    if (fieldWrap.querySelector('.wcpa_selected, .wcpa_color_selected')) {
      return true;
    }

    const textInput = fieldWrap.querySelector('input[type="text"], input[type="email"], input[type="tel"], textarea');
    if (textInput) {
      return textInput.value.trim().length > 0;
    }

    const select = fieldWrap.querySelector('select');
    if (select) {
      return select.value.trim().length > 0;
    }

    return false;
  }

  function createHeader(step, index) {
    const row = document.createElement('div');
    row.className = `wcpa_row ${HEADER_CLASS} chs-aco-step`;
    row.dataset.chsStepHeader = String(index);

    const button = document.createElement('button');
    button.className = 'chs-aco-step__header';
    button.type = 'button';
    button.setAttribute('aria-expanded', 'false');

    const number = document.createElement('span');
    number.className = 'chs-aco-step__number';
    number.textContent = String(index + 1);

    const title = document.createElement('span');
    title.className = 'chs-aco-step__title';
    title.textContent = translate(step.titleKey) || step.title;

    button.append(number, title);
    row.appendChild(button);

    return { row, button };
  }

  function createActions(index) {
    const row = document.createElement('div');
    row.className = `wcpa_row ${ACTIONS_CLASS}`;
    row.dataset.chsStepActions = String(index);

    const actions = document.createElement('div');
    actions.className = 'chs-aco-step__actions';

    const button = document.createElement('button');
    button.className = 'chs-aco-step__next';
    button.type = 'button';
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');

    const label = document.createElement('span');
    label.textContent = translate('next');

    const icon = document.createElement('i');
    icon.className = 'fa-solid fa-arrow-down';
    icon.setAttribute('aria-hidden', 'true');

    button.append(label, icon);

    actions.appendChild(button);
    row.appendChild(actions);

    return { row, button };
  }

  function assignRows(sectionBody, stepObjects) {
    let currentStepIndex = 0;
    const steps = stepObjects.map((step) => step.config);

    getManagedRows(sectionBody).forEach((row) => {
      const label = getFieldLabel(row);
      currentStepIndex = findStepIndex(label, currentStepIndex, steps);
      row.dataset.chsStep = String(currentStepIndex);
    });

    stepObjects.forEach((step, index) => {
      const rows = getManagedRows(sectionBody).filter((row) => row.dataset.chsStep === String(index));
      const firstRow = rows[0] || null;
      const lastRow = rows[rows.length - 1] || step.headerRow;

      if (firstRow && step.headerRow.nextElementSibling !== firstRow) {
        sectionBody.insertBefore(step.headerRow, firstRow);
      } else if (!firstRow && !step.headerRow.parentElement) {
        sectionBody.appendChild(step.headerRow);
      }

      if (step.actionsRow) {
        const afterActions = lastRow.nextElementSibling;
        if (afterActions !== step.actionsRow) {
          sectionBody.insertBefore(step.actionsRow, afterActions);
        }
      }
    });
  }

  function updateStepValidity(sectionBody, step) {
    const fields = getManagedRows(sectionBody)
      .filter((row) => row.dataset.chsStep === String(step.index))
      .flatMap((row) => Array.from(row.querySelectorAll('.wcpa_field_wrap')));
    const isValid = fields.every(isFieldValid);

    if (step.nextButton) {
      step.nextButton.disabled = !isValid;
      step.nextButton.setAttribute('aria-disabled', String(!isValid));
    }

    step.headerRow.classList.toggle('is-valid', isValid);
    return isValid;
  }

  function updateHeaderAccess(stepObjects, maxUnlockedIndex) {
    stepObjects.forEach((step) => {
      const canOpen = step.index <= maxUnlockedIndex;
      step.headerButton.disabled = !canOpen;
      step.headerButton.setAttribute('aria-disabled', String(!canOpen));
      step.headerRow.classList.toggle('is-locked', !canOpen);
    });
  }

  function openStep(sectionBody, stepObjects, activeIndex, maxUnlockedIndex) {
    const managedRows = getManagedRows(sectionBody);

    managedRows.forEach((row) => {
      const rowStepIndex = Number(row.dataset.chsStep);
      const isOpen = rowStepIndex <= maxUnlockedIndex;
      row.classList.toggle('chs-aco-step-row--active', isOpen);
      row.classList.toggle('chs-aco-step-row--hidden', !isOpen);
      row.classList.remove(END_ROW_CLASS);
      row.setAttribute('aria-hidden', String(!isOpen));
    });

    stepObjects.forEach((step) => {
      const isActive = step.index === activeIndex;
      const isOpen = step.index <= maxUnlockedIndex;
      const isLocked = step.index > maxUnlockedIndex;
      const stepRows = managedRows.filter((row) => row.dataset.chsStep === String(step.index));
      const lastRow = stepRows[stepRows.length - 1];
      step.headerRow.classList.toggle('is-active', isActive);
      step.headerRow.classList.toggle('is-open', isOpen);
      step.headerRow.classList.toggle('is-complete', step.index < activeIndex);
      step.headerButton.setAttribute('aria-expanded', String(isOpen));
      step.headerButton.disabled = isOpen || isLocked;
      step.headerButton.setAttribute('aria-disabled', String(isOpen || isLocked));

      if (step.actionsRow) {
        step.actionsRow.classList.toggle('chs-aco-step-row--active', isActive);
        step.actionsRow.classList.toggle('chs-aco-step-row--hidden', !isActive);
        step.actionsRow.setAttribute('aria-hidden', String(!isActive));
      }

      if (lastRow && isOpen && (!step.actionsRow || !isActive)) {
        lastRow.classList.add(END_ROW_CLASS);
      }
    });
  }

  function getStickyHeaderOffset() {
    const header = document.querySelector('.shopify-section-header-sticky .header, .header.is-sticky, sticky-header .header, .header');

    if (!header) {
      return 0;
    }

    const rect = header.getBoundingClientRect();
    return rect.height > 0 ? rect.height + 8 : 0;
  }

  function scrollStepBelowHeader(step) {
    window.requestAnimationFrame(() => {
      const rect = step.headerRow.getBoundingClientRect();
      const top = rect.top + window.pageYOffset - getStickyHeaderOffset();

      window.scrollTo({
        top: Math.max(0, top),
        behavior: 'smooth'
      });
    });
  }

  function buildStepper(form) {
    if (form.classList.contains(READY_CLASS)) {
      return true;
    }

    const sectionBody = form.querySelector('.wcpa_section_body');
    const rows = sectionBody ? getManagedRows(sectionBody) : [];

    if (!sectionBody || rows.length < 4) {
      return false;
    }

    hydrateSelectedInputs(form);
    syncSelectionState(form);
    const config = getStepperConfig(form);
    sectionBody.classList.add('chs-aco-stepper');
    if (config.className) {
      sectionBody.classList.add(config.className);
    }

    const stepObjects = config.steps.map((step, index) => {
      const header = createHeader(step, index);
      const actions = index < config.steps.length - 1 ? createActions(index) : null;

      return {
        index,
        config: step,
        headerRow: header.row,
        headerButton: header.button,
        actionsRow: actions ? actions.row : null,
        nextButton: actions ? actions.button : null
      };
    });

    let activeIndex = 0;
    let maxUnlockedIndex = 0;
    let refreshQueued = false;

    const refresh = () => {
      syncSelectionState(form);
      assignRows(sectionBody, stepObjects);
      stepObjects.forEach((step) => updateStepValidity(sectionBody, step));
      updateHeaderAccess(stepObjects, maxUnlockedIndex);
      openStep(sectionBody, stepObjects, activeIndex, maxUnlockedIndex);
    };

    const queueRefresh = () => {
      if (refreshQueued) {
        return;
      }

      refreshQueued = true;
      window.requestAnimationFrame(() => {
        refreshQueued = false;
        refresh();
      });
    };

    stepObjects.forEach((step) => {
      step.headerButton.addEventListener('click', () => {
        if (step.headerRow.classList.contains('is-open')) {
          return;
        }

        if (step.index <= maxUnlockedIndex) {
          activeIndex = step.index;
          refresh();
          scrollStepBelowHeader(step);
        }
      });

      if (!step.nextButton) {
        return;
      }

      step.nextButton.addEventListener('click', () => {
        if (!updateStepValidity(sectionBody, step)) {
          return;
        }

        activeIndex = step.index + 1;
        maxUnlockedIndex = Math.max(maxUnlockedIndex, activeIndex);
        refresh();
        scrollStepBelowHeader(stepObjects[activeIndex]);
      });
    });

    form.addEventListener('change', refresh);
    form.addEventListener('input', refresh);
    form.addEventListener('click', () => window.setTimeout(queueRefresh, 0));

    const observer = new MutationObserver(queueRefresh);
    observer.observe(sectionBody, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'checked', 'aria-hidden']
    });

    form.classList.add(READY_CLASS);
    refresh();
    return true;
  }

  function init() {
    const forms = Array.from(document.querySelectorAll('.product__app-block .wcpa_form_outer'));
    const initialized = forms.some(buildStepper);

    if (!initialized && attempts < MAX_ATTEMPTS) {
      attempts += 1;
      window.setTimeout(init, 250);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
